// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"7b52acfa","331":"e3885008","420":"3deaea27","523":"7d4b3ddb","603":"8bf59032","678":"479f4d50","736":"54f26a5f","872":"9a6dda4b","915":"b07b1742"}[chunkId] + ".chunk.css";
};